"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayloadService = void 0;
const tsyringe_1 = require("tsyringe");
const proxyWalletService_1 = require("../proxyWalletService/proxyWalletService");
const required_1 = require("../../../../helpers/required/required");
const lodash_1 = require("lodash");
const rightService_1 = require("../../../utils/services/rightService/rightService");
let PayloadService = class PayloadService {
    constructor(messagingWallet) {
        this.messagingWallet = messagingWallet;
        this.verifyPayloadSignatures = rightService_1.RightService.verifyPayloadSignatures;
        this.hydratePayloadParameters = (params) => __awaiter(this, void 0, void 0, function* () {
            params.authorizations = this.messagingWallet.authorizations;
            params.nonce = Date.now().toString();
            return yield this.globalSignPayload(params);
        });
    }
    /**
     * Add signature of this payload in params.signature
     * @param payload
     * @returns {Promise<any>}
     */
    globalSignPayload(params) {
        return __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(params, 'params payload should not be null');
            required_1.requiredDefined(params.authorizations, 'params.authorizations rpc payload should not be null');
            const payloadClone = lodash_1.cloneDeep(params);
            payloadClone.signature = yield this.messagingWallet.signer(JSON.stringify(params));
            return payloadClone;
        });
    }
};
PayloadService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [proxyWalletService_1.ProxyWalletService])
], PayloadService);
exports.PayloadService = PayloadService;
//# sourceMappingURL=payloadService.js.map